<template>
  <li class="logo">
    <nuxt-link to="/">
      <img
        src="/logo.svg"
        alt="Логотип Реплеи | Мир Кораблей"
        loading="eager"
      />
    </nuxt-link>
  </li>
</template>

<style scoped lang="postcss">
.logo {
  display: flex;
  align-items: stretch;

  a {
    display: flex;
    align-items: center;
    padding: 0 20px 0 0;

    img {
      width: 141px;
    }
  }
}
</style>
